module.exports = __webpack_public_path__ + "media/images/flags/16/Switzerland-1a7177f2d3531720d40927de490ec63f.png";